// Template placeholder helpers. Placeholders look like `<<NAME>>` — chosen
// because the angle-bracket pair is rare in plain markdown (HTML tags live
// inside individual angle brackets, never doubled). The regex tolerates
// internal whitespace so `<< first name >>` works for human-friendly names.
import { PLACEHOLDER_REGEX } from "@shared/types";
export function findPlaceholders(content) {
    const seen = new Set();
    const out = [];
    for (const match of content.matchAll(PLACEHOLDER_REGEX)) {
        const name = match[1].trim();
        if (!name || seen.has(name))
            continue;
        seen.add(name);
        out.push(name);
    }
    return out;
}
export function applyPlaceholders(content, values) {
    return content.replace(PLACEHOLDER_REGEX, (_, raw) => {
        const name = String(raw).trim();
        const v = values[name];
        return typeof v === "string" && v.length > 0 ? v : `<<${name}>>`;
    });
}
